import { F0Box, F0Button } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import type { PurchaseOrderListNavigation } from './usePurchaseOrderListNavigation'

interface SidepanelDialogTitleProps {
  navigation?: PurchaseOrderListNavigation
  /**
   * When the dialog is in edit mode, navigation should be hidden
   * (unsaved changes warning would be needed otherwise).
   */
  hideNavigation?: boolean
}

const SidepanelDialogTitle = ({
  navigation,
  hideNavigation = false,
}: SidepanelDialogTitleProps) => {
  if (hideNavigation || !navigation) return null

  return (
    <F0Box display="flex" flexDirection="row" alignItems="center" gap="xs">
      <F0Button
        variant="ghost"
        size="sm"
        icon={ChevronUp}
        hideLabel
        label={i18n.t('common.pagination.previous')}
        onClick={navigation.onPrev}
        disabled={!navigation.canGoPrev}
      />
      <F0Button
        variant="ghost"
        size="sm"
        icon={ChevronDown}
        hideLabel
        label={i18n.t('common.pagination.next')}
        onClick={navigation.onNext}
        disabled={!navigation.canGoNext}
      />
    </F0Box>
  )
}

export default SidepanelDialogTitle
